import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { ISelfReturnRequest } from '../../interfaces/return-list/self-return-request.interface';
import { AbstractReturnPaymentService } from '../abstraction/abstract.return-payment.service';

@Injectable({
  providedIn: 'root',
})
export class MockReturnPaymentService extends AbstractReturnPaymentService {
  private returnPaymentReasonCodeListJson =
    'assets/mocks/fednow/returnpayment/returnPaymentReasonCodeList.json';
  private sendSelfReturnJson = 'assets/mocks/fednow/returnpayment/sendSelfReturn.json';

  constructor(private http: HttpClient) {
    super();
  }

  returnPaymentReasonCodeList(): Promise<any> {
    return lastValueFrom(this.http.get<any>(this.returnPaymentReasonCodeListJson));
  }

  sendSelfReturn(selfReturnRequest: ISelfReturnRequest): Promise<IWebMessage | undefined> {
    return lastValueFrom(this.http.get<IWebMessage>(this.sendSelfReturnJson));
  }
}
